import React from "react";
import Button from '@material-ui/core/Button';

class AlertModal extends React.Component {
    showClose = (e) => {
        this.props.showClose && this.props.showClose(e);
      };
    
      showOkay = (e) => {   
        this.props.showOkay && this.props.showOkay(e);
      };
    render() {
        if (this.props.isOpen === false)
            return null

        return (
            <div>
                <div className="modal">
                        <h3>{this.props.modalTitle}</h3>
                        <hr></hr>
                        <div className="alertModalBody">
                            <p>{this.props.message}</p>
                            {this.props.children}
                        </div>
                        <hr></hr>
                    <Button variant="contained" id="alertButtonColor" color="secondary" style={{float: "right"}}  onClick={this.showClose}>Ok</Button>
                </div>
            </div>
        )}
}

export default AlertModal;